import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const writeToFieldIfEmpty = (
  oldValue: string | null | undefined,
  newValue: string | null | undefined,
  writer: React.Dispatch<React.SetStateAction<string>>,
) => {
  if (!oldValue && !!newValue) {
    writer(newValue);
    return true;
  }
  return false;
};

export const hasFirstRecord = (list: Array<Record<string, unknown>> | null) => {
  if (!list || !list[0]) {
    return false;
  }
  if (list.length > 1) {
    return true;
  }
  return Object.keys(list[0]).reduce((dataPresent, key) => {
    return dataPresent || (!!list[0][key] && key !== "key");
  }, false);
};
